var background = "https://shopfront-cdn.tekoapis.com/static/242be5f20fc8b658.svg";

export { background as default };
